import { ServiceContext } from "./service-context";

export abstract class ApiClientFilter {
  abstract invoke(
    context: ServiceContext,
    next: (serviceContext: ServiceContext) => Promise<void>,
  ): Promise<void>;
}
